export default "https://assets.egbcdn.net/assets/packs/_/images/beer/st_patrick/beer-vessel-e176061cf6ff6e18ab745b67932206f9.png";